import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

interface RecruiterRedirectGuardProps {
  children: React.ReactNode;
}

export const RecruiterRedirectGuard = ({ children }: RecruiterRedirectGuardProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkUserType = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      
      if (session?.user?.user_metadata?.user_type === 'recruiter') {
        console.log('Recruiter detected on job seeker route, redirecting...');
        navigate('/recruiter/dashboard', { replace: true });
      }
    };

    checkUserType();
  }, [navigate]);

  return <>{children}</>;
};